export const FlooringTypes: string[] = [
  'Hardwood',
  'Luxury Vinyl',
  'Laminate',
  'Carpet',
  'Natural Stone',
  'Tile',
  'Waterproof Flooring',
  'Glass Tile',
  'Metal Tile',
  'Solid Surface',
  'Vinyl', // Alias for Vinyl Sheet Goods
  'Vinyl Sheet Goods',
  'Carpet Tile',
  'Area Rugs',
  'Cork',
];

const BathingTypes = [
  'bathing.bathtub',
  'bathing.screen',
  'bathing.wall',
  'bathing.panel',
  'bathing.feet',
  'bathing.cradle',
  'bathing.grip',
  'bathing.bathtub.kit',
];

const CabinetryTypes = [
  'cabinetry.cabinet',
  'cabinetry.front',
  'cabinetry.filler',
  'cabinetry.handle',
  'cabinetry.hardware',
  'cabinetry.molding',
  'cabinetry.panel',
];

const WorktopTypes = [
  'worktop',
  'worktop.slab',
  'worktop.precut',
  'worktop.backsplash',
  'worktop.backsplash.precut',
  'worktop.cutout',
  'worktop.edge',
  'worktop.edgeCut',
  'worktop.joint',
  'worktop.wallStrip',
  'worktop.waterfall',
  'worktop.integratedSink',
  'worktop.component',
];

export const ProductTypes: string[] = [
  ...BathingTypes,
  ...CabinetryTypes,
  ...FlooringTypes,
  ...WorktopTypes,
];

export type ProductType = (typeof ProductTypes)[number];
